// ⚠️ MOCK — dados ilustrativos para validação com o cliente.
// Remover este arquivo quando as queries reais forem implementadas (ver PRD §14).
//
// Segurança Física (PhysicalSecurity + PhysicalSecurityMember).
// As INTERFACES são o CONTRATO das futuras queries.
//
// LIMITAÇÕES DO MODELO (levar à validação com o cliente):
//  - PhysicalSecurity não tem vínculo com Unity nem Country → não há recorte por planta/país.
//  - PhysicalSecurityMember não tem createdAt → não há histórico temporal de efetivo.

export interface PhysicalSecurityKpis {
    activeCompanies: number;    // empresas com companyStatus=true
    inactiveCompanies: number;  // companyStatus=false
    totalStations: number;      // SUM(stationNumber)
    totalStaff: number;         // total de PhysicalSecurityMember
    activeStaff: number;        // members com status=true
    staffPerStation: number;    // efetivo ativo / postos (ex.: 3.8)
}

// Gráfico 1 — Efetivo por empresa (BarChart horizontal)
export interface StaffByCompanyRow {
    company: string;
    staff: number;
}

// Gráfico 2 — Empresas ativas × inativas (PieChart donut)
export interface CompanyStatusRow {
    status: 'active' | 'inactive';
    count: number;
}

// Gráfico 3 — Postos × efetivo alocado (ColumnChart agrupado)
export interface StationsVsStaffRow {
    company: string;
    stations: number;
    staff: number;
}

// Gráfico 4 — Empresas cadastradas por período (ColumnChart, PhysicalSecurity.createdAt)
// (PhysicalSecurityMember não tem createdAt → não dá para série de efetivo; usamos o
//  createdAt da EMPRESA, que existe.)
export interface CompaniesByQuarterRow {
    quarter: string;    // 'T3/24' …
    count: number;
}

// Gráfico 5 — Status do efetivo por empresa (ColumnChart percent)
// base real: PhysicalSecurityMember.status (bool).
export interface StaffStatusByCompanyRow {
    company: string;
    active: number;
    inactive: number;
}

// ===========================================================================

export const MOCK_KPIS: PhysicalSecurityKpis = {
    activeCompanies: 7,
    inactiveCompanies: 2,
    totalStations: 48,
    totalStaff: 183,
    activeStaff: 171,
    staffPerStation: 3.8,
};

// soma = 183 (= totalStaff)
export const MOCK_STAFF_BY_COMPANY: StaffByCompanyRow[] = [
    {company: 'Vanguarda Segurança', staff: 34},
    {company: 'Proteção Total', staff: 29},
    {company: 'GRS Vigilância', staff: 26},
    {company: 'Águia Vigilância', staff: 25},
    {company: 'Sentinela Serviços', staff: 24},
    {company: 'Guardian Corp', staff: 23},
    {company: 'Fortaleza Segurança', staff: 22},
];

export const MOCK_COMPANY_STATUS: CompanyStatusRow[] = [
    {status: 'active', count: 7},
    {status: 'inactive', count: 2},
];

// stations soma = 48 (= totalStations). Fortaleza está sub-dimensionada (22/8 = 2.75x < 3x).
export const MOCK_STATIONS_VS_STAFF: StationsVsStaffRow[] = [
    {company: 'Vanguarda Segurança', stations: 9, staff: 34},
    {company: 'Proteção Total', stations: 8, staff: 29},
    {company: 'GRS Vigilância', stations: 7, staff: 26},
    {company: 'Águia Vigilância', stations: 5, staff: 25},
    {company: 'Sentinela Serviços', stations: 6, staff: 24},
    {company: 'Guardian Corp', stations: 5, staff: 23},
    {company: 'Fortaleza Segurança', stations: 8, staff: 22},
];

// soma = 9 (= activeCompanies + inactiveCompanies)
export const MOCK_COMPANIES_BY_QUARTER: CompaniesByQuarterRow[] = [
    {quarter: 'T3/24', count: 1},
    {quarter: 'T4/24', count: 0},
    {quarter: 'T1/25', count: 2},
    {quarter: 'T2/25', count: 1},
    {quarter: 'T3/25', count: 1},
    {quarter: 'T4/25', count: 2},
    {quarter: 'T1/26', count: 1},
    {quarter: 'T2/26', count: 1},
];

// active soma = 171 (= activeStaff); inactive soma = 12; total por empresa = MOCK_STAFF_BY_COMPANY
export const MOCK_STAFF_STATUS_BY_COMPANY: StaffStatusByCompanyRow[] = [
    {company: 'Vanguarda Segurança', active: 32, inactive: 2},
    {company: 'Proteção Total', active: 27, inactive: 2},
    {company: 'GRS Vigilância', active: 25, inactive: 1},
    {company: 'Águia Vigilância', active: 24, inactive: 1},
    {company: 'Sentinela Serviços', active: 23, inactive: 1},
    {company: 'Guardian Corp', active: 20, inactive: 3},
    {company: 'Fortaleza Segurança', active: 20, inactive: 2},
];
